import React from "react";
import UnopDropdown from "unop-react-dropdown";
import { GrSort } from 'react-icons/gr'
import { Container } from "react-bootstrap";
const SearchCountNumber = ({ title, onClick }) => {
  const handler = () => {

  }
  const sortHandle = (sortValue) => {
    localStorage.setItem("sortType",sortValue);
    onClick();
  }
  return (
    <Container>
      <div className="d-flex justify-content-between pt-3 px-2">
        <div className="">{title}</div>
        <div className="d-flex ">
          <UnopDropdown
            onAppear={handler}
            onDisappearStart={handler}
            trigger={
              <p className="mx-1">
                Sort By
                <GrSort className="mx-2" />
              </p>
            }
            delay={0}
            align="CENTER"
            hover
          >
            <div className="dark-bg p-3 text-white w-150px">
              <div onClick={() => { sortHandle("Reset Sort") }} className="border-bottom py-2"> Reset Sort </div>
              <div onClick={() => { sortHandle("Best Seller") }} className="border-bottom py-2"> Best Seller </div>
              <div onClick={() => { sortHandle("Price A to Z") }} className="border-bottom py-2">Price A to Z</div>
              <div onClick={() => { sortHandle("Price Z to A") }} className="py-2">Price Z to A</div>
            </div>
          </UnopDropdown>
        </div>
      </div>
    </Container>

  );
};

export default SearchCountNumber;
